import './sociallink.less'

import {Icon} from '@codeurs/front'
import React from 'react'
import {Mod, style} from 'util/style'

const styles = style('sociallink')

export const Sociallink: React.FC<{
	type: string
	url: string
	mod?: Mod<'big'>
}> = ({type, url, mod}) => {
	if (!url) return
	const typeLowerCase = type.toLowerCase()

	return (
		<a
			href={url}
			target={'_blank'}
			class={styles.mod(typeLowerCase).mod(mod)}
			title={type}
		>
			<Icon icon={typeLowerCase} />
		</a>
	)
}
